import {
    type GetAllProfileUpdateRequestsResponseType,
    type GetAllProfileUpdateRequestsRequestType
} from "./type";
import {
    request
} from "../request";

const getAllProfileUpdateRequests = async (
    params: GetAllProfileUpdateRequestsRequestType
): Promise<GetAllProfileUpdateRequestsResponseType> => {
    const searchParams = new URLSearchParams();

    if(params.search) {
        searchParams.append("search", params.search);
    }

    if(params.page !== undefined) {
        searchParams.append("page", String(params.page));
    }

    const queryStr = searchParams.toString();
    const endpoint = queryStr ? `/request/getAllProfileUpdateRequests?${queryStr}` : "/request/getAllProfileUpdateRequests";

    return await request<GetAllProfileUpdateRequestsResponseType>(endpoint, {
        method: "GET"
    });
};
export default getAllProfileUpdateRequests;
